import { render, staticRenderFns } from "./relationship-list.vue?vue&type=template&id=5f3f4b52&"
import script from "./relationship-list.vue?vue&type=script&lang=js&"
export * from "./relationship-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports